module.exports = __webpack_public_path__ + "img/menu.8f319d13.svg";